import {http} from "../http";

export interface SwiftRub{
    trnRequestType : string;
    PMTTYPECODE : string;
    PMTCUSTID : string;
    CUSTCIF : string;
    CUSTACC : string;
    AMOUNT : number;
    BENEFNAME : string;
    BENEFTAXID : string;
    BENEFKPP : string;
    BENEFACC : string;
    BENEFBANKBIC : string;
    BENEFBANKCORACC : string;
    BENEFACC : string;
    BENEFBANKNAME : string;
    BENEFBANKADDR : string;
    PMTDET : string;
    INFOTOBENEF : string;
    CUSTACCFORCOM : string;
    COMMAMOUNT : string;
}

export const newMoneyTransferSwiftRub = async (request_data: SwiftRub): Promise<SwiftRub> => {
    const { data } = await http.post<SwiftRub>("moneytransfer/swiftrub", request_data);
    return data;
};
